import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import React from "react";
import { Typography } from "@mui/material";

export const FRow = styled(
  ({ children, className, fullWidth, component, ...other }) => {
    const NC = component || "div";
    return (
      <NC
        className={className}
        style={{
          ...other,
          display: "flex",
          flex: fullWidth ? 1 : 0,
          flexDirection: "row",
        }}
      >
        {children}
      </NC>
    );
  }
)({});

export const FCol = styled(({ children, fullWidth, component, ...other }) => {
  const NC = component || "div";
  return (
    <NC
      style={{
        ...other,
        display: "flex",
        flex: fullWidth ? 1 : 0,
        flexDirection: "column",
      }}
    >
      {children}
    </NC>
  );
})({});

const CustomTypography = ({
  color,
  startIcon,
  centered,
  endIcon,
  stretch,
  background,
  ...other
}) => {
  return startIcon ? (
    <span
      style={{
        background,
        display: "flex",
        justifyContent: centered ? "center" : "flex-start",
        alignItems: "center",
        width: !stretch ? "100%" : null,
      }}
    >
      {startIcon}&nbsp;
      <Typography color={"primary"} component="span" {...other} />
    </span>
  ) : endIcon ? (
    <span
      style={{
        background,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        width: !stretch ? "100%" : null,
      }}
    >
      <Typography color={"primary"} component="span" {...other} />
      &nbsp;{endIcon}
    </span>
  ) : (
    <Typography color={"primary"} component="span" {...other} />
  );
};

export const StandardText = styled(CustomTypography)(
  ({ align, color, size, bold, light, theme }) => ({
    textAlign: align || "justify",
    color:
      color === "primary"
        ? theme.palette.text.primary
        : color === "secondary"
        ? theme.palette.text.secondary
        : color || "#000",
    fontSize: size || 20 + "px",
    //fontFamily: "'Montserrat', sans-serif",
    fontWeight: bold ? 900 : light ? 200 : 600,
  })
);

export const StandardButton = styled(({ ...other }) => <Button {...other} />)(
  ({ disabled, color, bordered, theme, ...other }) => ({
    opacity: disabled ? "0.6" : 1,
    alignSelf: "center",
    padding: "5px",
    boxShadow:
      color === "red"
        ? "0 1px 3px 0px rgba(0, 0, 0, .3)"
        : "0 1px 3px 0px rgba(0, 0, 0, .3)",
    backgroundColor: "rgba(255,255,255,0.95)",
    border: "0px solid #fff",
    borderBottom: bordered
      ? `3px solid ${theme.pallete.primary}`
      : "0px solid white",
    elevation: 5,
    borderRadius: "4px",
    justifyContent: "center",
  })
);
